/**
 * Ask the current origin for a one-time code, then open the other product.
 * The code travels in the URL fragment. Redeem happens on the target origin.
 */
import { getConfig } from './runtime.js';

function accessToken() {
  const keys = getConfig()?.STORAGE_KEYS;
  if (!keys || typeof localStorage === 'undefined') return '';
  try {
    return localStorage.getItem(keys.ACCESS) || '';
  } catch {
    return '';
  }
}

function apiUrl(path) {
  const origin = getConfig()?.apiOrigin?.();
  if (!origin) return path;
  return `${String(origin).replace(/\/$/, '')}${path}`;
}

export async function requestHandoff(targetProduct, nextPath) {
  const token = accessToken();
  const response = await fetch(apiUrl('/api/auth/handoff/'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({
      target_product: targetProduct,
      source_product: getConfig()?.APP?.productKey || '',
      next: nextPath || '/',
    }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.detail || 'Could not switch apps.');
    error.status = response.status;
    error.code = data.error;
    throw error;
  }
  return data;
}

export async function redeemHandoff(code, nextPath) {
  const response = await fetch(apiUrl('/api/auth/handoff/redeem/'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      code,
      ...(nextPath ? { next: nextPath } : {}),
    }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.detail || 'This switch link is not valid.');
    error.status = response.status;
    error.code = data.error;
    throw error;
  }
  return data;
}

export function storeHandoffSession(payload) {
  const keys = getConfig()?.STORAGE_KEYS;
  if (!keys || typeof localStorage === 'undefined') return;
  if (payload.access) localStorage.setItem(keys.ACCESS, payload.access);
  if (payload.refresh) localStorage.setItem(keys.REFRESH, payload.refresh);
  localStorage.removeItem(keys.USER);
}
